define.alias("shared/components/shared/carousel/controls", "media/components/shared/carousel/controls");